import { useEffect } from "preact/hooks";

export default function useWindowEventListener(eventName: string, callback: () => void) {
    useEffect(() => {
        window.addEventListener(eventName, callback);

        return () => window.removeEventListener(eventName, callback);
    });
}
